<template>
    <v-flex xs12>
        <span style="font-size: 16pt;"><br /></span>
    </v-flex>
</template>

<script>
    export default {
        name: 'Spacer'
    }
</script>

<style>
</style>
